// extracted by mini-css-extract-plugin
module.exports = {"configureTable":"GenericConfigureTable_configureTable__3XZQi","table":"GenericConfigureTable_table__1DZ2D","addButton":"GenericConfigureTable_addButton__1BIIR"};